// Carry Roll ThemeSelector — light / dark / system preference.

import { Monitor, Moon, Sun, type LucideIcon } from 'lucide-react';
import { useTheme } from '../../lib/useTheme';
import type { Theme } from '../../store/settingsSlice';

const THEMES: { value: Theme; label: string; icon: LucideIcon }[] = [
  { value: 'system', label: 'System', icon: Monitor },
  { value: 'light', label: 'Light', icon: Sun },
  { value: 'dark', label: 'Dark', icon: Moon },
];

export function ThemeSelector() {
  const { theme, setTheme } = useTheme();

  return (
    <div data-testid="theme-selector" className="flex items-center justify-between">
      <span className="field-label">Theme</span>
      <div className="flex gap-1">
        {THEMES.map(({ value, label, icon: Icon }) => (
          <button
            key={value}
            type="button"
            className="btn icon-btn"
            aria-pressed={theme === value}
            aria-label={`Set theme to ${label}`}
            title={label}
            onClick={() => setTheme(value)}
            style={
              theme === value
                ? { borderColor: 'var(--color-accent)', color: 'var(--color-accent)' }
                : undefined
            }
          >
            <Icon size={18} aria-hidden="true" />
          </button>
        ))}
      </div>
    </div>
  );
}
